module.exports = ".location-logs{width:100%;display:block;clear:both;cursor:pointer;padding:5px 5px}.location-logs .list-header{font-size:12px}.location-logs .list-header i{font-size:16px}.location-logs .list-item{padding:0px;position:relative}.location-logs .list-item::after{content:'';display:block;width:100%;margin-top:1px;border-bottom:1px solid #404040}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/clock-in-out/shared/ui/location/location.component.scss
// module id = 1069
// module chunks = 0